module.exports = __webpack_public_path__ + "img/Surface4.187ee455.jpg";